// MR. BOSS & CO. — product data
// All hardcoded as per brief. Adjustable: edit this file.
//
// To add real product photography, drop files into /app/frontend/public/products/
// using the GV code in lowercase + hyphen (e.g. 'gv-4439.jpg'). They will
// auto-resolve via getProductImage(code). When no file exists, the dark
// placeholder rectangle is shown by ProductImage's onError fallback.
//
// Set hero images: /app/frontend/public/products/set-<slug>.jpg
// (auto-written by the admin page when "Generate hero" is clicked).

export const BRAND = {
  name: 'MR. BOSS & CO.',
  tagline: 'The room always notices.',
  subtagline: 'Curated leather gift sets for the people who run things.',
  email: 'atelier@mrbossandco.com',
  phone: '+1 (212) 555 0199',
  address: 'By appointment only',
};

// Master product catalog — each unique GV item referenced by the sets.
// Adjust freely to extend or edit without touching sets.
export const PRODUCTS = {
  'GV 4439': {
    code: 'GV 4439',
    name: 'Leather wallet',
    category: 'Wallets',
    dimensions: '11 × 9 cm',
    leather: 'Nappa black',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 4439-6' }],
    features: ['Card slots', 'Bill compartment', 'Coin pocket'],
    description:
      'A classic bifold cut to the millimetre. Card slots angled for the thumb, bill compartment lined in matte twill.',
  },
  'GV 4888': {
    code: 'GV 4888',
    name: 'RFID card holder',
    category: 'Wallets',
    dimensions: '10.5 × 7 cm',
    leather: 'Nappa black',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 4888-6' }],
    features: ['RFID + NFC', 'Accordion card bay'],
    description:
      'A quiet sliver of Nappa that stops the pick-pockets you can see and the ones you cannot.',
  },
  'GV 5104': {
    code: 'GV 5104',
    name: 'Slim business bag',
    category: 'Business Bags',
    dimensions: '41 × 28 cm',
    leather: 'Nappa black',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 5104-6' }],
    features: ['15.6" laptop', 'Top handle', 'Detachable shoulder strap'],
    description:
      'Cut thin enough to disappear under the arm, structured enough to hold the meeting.',
  },
  'GV 4861': {
    code: 'GV 4861',
    name: 'RFID + NFC wallet',
    category: 'Wallets',
    dimensions: '10 × 7.5 cm',
    leather: 'Hunter & Italian leather',
    colors: [
      { label: 'Camel light', hex: '#b39073', ref: 'GV 4861-3' },
      { label: 'Camel black', hex: '#352722', ref: 'GV 4861-4' },
      { label: 'Camel dark', hex: '#5a3e2b', ref: 'GV 4861-5' },
      { label: 'Italian black', hex: '#1a1a1a', ref: 'GV 4861-8' },
      { label: 'Italian brown', hex: '#4a2a1a', ref: 'GV 4861-9' },
    ],
    features: ['RFID + NFC', 'Hunter leather', 'Blind embossed crest'],
    description:
      'The wallet for men who still carry a wallet. Shielded, slim, hand-finished in five house leathers.',
  },
  'GV 4944': {
    code: 'GV 4944',
    name: 'Luxury business bag',
    category: 'Business Bags',
    dimensions: '41 × 30 × 7 cm',
    leather: 'Italian black',
    colors: [
      { label: 'Black', hex: '#1a1a1a', ref: 'GV 4944-6' },
      { label: 'Brown', hex: '#3e2418', ref: 'GV 4944-7' },
    ],
    features: ['15.6" laptop', 'Italian leather', 'Brass hardware'],
    description:
      'Italian leather, edge-painted by hand. The kind of bag that tells the room you are not in a hurry.',
  },
  'GV 4889': {
    code: 'GV 4889',
    name: 'Smart card holder',
    category: 'Wallets',
    dimensions: '10 × 7 cm',
    leather: 'Nappa black / Italian black',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 4889-6' }],
    features: ['Card eject', 'RFID + NFC', 'Aluminium card tray'],
    description:
      'A single push and the top card rises like it was waiting for you.',
  },
  'GV 2466': {
    code: 'GV 2466',
    name: 'Travel wallet',
    category: 'Wallets',
    dimensions: '13 × 20 cm',
    leather: 'Nappa',
    colors: [
      { label: 'Black', hex: '#1a1a1a', ref: 'GV 2466-1' },
      { label: 'Brown', hex: '#3e2418', ref: 'GV 2466-2' },
    ],
    features: ['Passport fit', 'Boarding pass sleeve', 'Press-stud closure'],
    description:
      'Long-form wallet cut to hold a passport flat. Built for the jetway, not the junk drawer.',
  },
  'GV 4346': {
    code: 'GV 4346',
    name: 'Passport holder',
    category: 'Accessories',
    dimensions: '10 × 14 cm',
    leather: 'Hunter & Italian leather',
    colors: [
      { label: 'Camel dark', hex: '#4a2f1e', ref: 'GV 4346-7' },
      { label: 'Camel light', hex: '#a07d5b', ref: 'GV 4346-3' },
      { label: 'Italian brown', hex: '#3e2418', ref: 'GV 4346-9' },
    ],
    features: ['Passport fit', 'Soft-touch hunter leather'],
    description:
      'A soft case that patinas with every border it sees.',
  },
  'GV 2468': {
    code: 'GV 2468',
    name: 'Luxury toiletry bag',
    category: 'Travel',
    dimensions: '28 × 14 cm',
    leather: 'Nappa black',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 2468-6' }],
    features: ['Zip closure', 'Water-resistant lining', 'Leather hand loop'],
    description:
      'A dopp kit with the silhouette of a cigar case. Inside: a wipe-clean liner you will never curse.',
  },
  'GV 4637': {
    code: 'GV 4637',
    name: 'Tie holder',
    category: 'Travel',
    dimensions: '40 × 13 cm',
    leather: 'Nappa',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 4637-6' }],
    features: ['Holds 3 ties', 'Roll-up', 'Zip closure'],
    description:
      'Three ties, rolled into a leather cigar of silk. No wrinkles, no apologies.',
  },
  'GV 4638': {
    code: 'GV 4638',
    name: 'Shirt folder',
    category: 'Travel',
    dimensions: '42 × 30 × 12 cm',
    leather: 'Nappa / Nappa black',
    colors: [{ label: 'Black', hex: '#1a1a1a', ref: 'GV 4638-6' }],
    features: ['Fold-flat design', 'Magnetic closure', 'Press-fit corners'],
    description:
      'Keeps the dress shirt pressed from the car to the keynote.',
  },
  'GV 4943': {
    code: 'GV 4943',
    name: 'Premium business bag',
    category: 'Business Bags',
    dimensions: '41 × 30 × 8 cm',
    leather: 'Italian black',
    colors: [
      { label: 'Black', hex: '#1a1a1a', ref: 'GV 4943-6' },
      { label: 'Brown', hex: '#3e2418', ref: 'GV 4943-7' },
    ],
    features: ['17.3" laptop', 'Italian leather', 'Padded sleeve', 'Saddle-stitched'],
    description:
      'The flagship carry. Italian shoulder-cut leather, saddle-stitched by hand.',
  },
};

// Ordered set definitions — four sets. Items may be a catalogue code
// ('GV 4943') or the name of a piece still to be photographed and coded
// (see PENDING_PIECES); resolveSetItem handles both.
export const SETS = [
  {
    slug: 'the-briefing',
    name: 'The Briefing',
    pieceCount: 4,
    leather: 'Nappa black',
    tagline: 'Everything the meeting requires. Nothing it does not.',
    description:
      'The working kit — briefcase, tie case, shirt travel case and an executive pen. Cut narrow, carried daily.',
    laptop: '15.6"',
    featured: false,
    items: ['GV 5104', 'GV 4637', 'GV 4638', 'GV 694'],
  },
  {
    slug: 'the-corner-office',
    name: 'The Corner Office',
    pieceCount: 7,
    leather: 'Italian & Nappa black',
    tagline: 'When the desk has a view.',
    description:
      'Seven pieces for the office that came with the promotion — briefcase, tie case, shirt case, notebook, business card holder, executive pen and toiletry bag.',
    laptop: '15.6"',
    featured: false,
    items: [
      'GV 4944',
      'GV 4637',
      'GV 4638',
      'GV 4422',
      'GV 4889',
      'GV 694',
      'GV 2468',
    ],
  },
  {
    slug: 'the-legacy',
    name: 'The Legacy',
    pieceCount: 9,
    leather: 'Italian & Nappa black',
    tagline: 'The room always notices.',
    description:
      'The house at full measure. Nine pieces — briefcase, tie case, shirt travel case, leather business card holder, passport holder, toiletry bag, desk pad, weekly calendar notebook and executive pen.',
    laptop: '17.3"',
    featured: true,
    items: [
      'GV 4943',
      'GV 4637',
      'GV 4638',
      'GV 4888',
      'GV 4346',
      'GV 2468',
      'GV 4686',
      'Weekly calendar notebook',
      'GV 694',
    ],
  },
  {
    slug: 'my-mr-boss',
    name: 'My Mr. Boss',
    pieceCount: 0,
    leather: 'Your choice of Italian or Nappa',
    tagline: 'Built piece by piece, by you.',
    description:
      'Choose a size and fill it yourself, or take the free hand and select every piece in the house. Assembled to your list, presented as one set.',
    laptop: null,
    featured: false,
    custom: true,
    items: [],
  },
];

export const getSetBySlug = (slug) => SETS.find((s) => s.slug === slug);

// Pieces committed to a set but not yet coded or photographed. They render
// with their name and an "awaiting photography" placeholder until the atelier
// swaps the entry for a real GV code.
export const PENDING_PIECES = {
  'Weekly calendar notebook': {
    name: 'Weekly calendar notebook',
    category: 'Stationery',
    description: 'A weekly planner in leather, dated by hand each year.',
  },
};

export const isPendingPiece = (entry, products = PRODUCTS) =>
  Boolean(PENDING_PIECES[entry]) || !(products?.[entry] || PRODUCTS[entry]);

// First item in a set that has a real catalogue code (and therefore a photo).
export const firstCodedItem = (set, products = PRODUCTS) =>
  (set?.items || []).find((entry) => Boolean(products?.[entry] || PRODUCTS[entry])) || null;

// Resolve a set item entry (code or pending piece name) into something
// renderable. `products` lets callers pass the merged catalogue.
export const resolveSetItem = (entry, products = PRODUCTS) => {
  const found = products?.[entry] || PRODUCTS[entry];
  if (found) return { ...found, codeRef: entry, pending: false };
  const pending = PENDING_PIECES[entry] || { name: entry };
  return {
    code: entry,
    codeRef: entry,
    dimensions: null,
    leather: null,
    features: [],
    colors: [],
    ...pending,
    pending: true,
  };
};

export const getSetItems = (set) =>
  set.items.map((code) => ({
    ...PRODUCTS[code],
    codeRef: code,
    image: getProductImage(code),
  }));

// Build the conventional public path for a product photo.
// URLs go through the backend /api/files proxy so images are served from
// object storage in production (with a graceful disk fallback in dev).
// The site falls back to a placeholder at runtime if the file does not
// exist (ProductImage onError handler).
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
const STORAGE_APP = 'mrbossco';

export const getProductImage = (code) =>
  `${API_BASE}/api/files/${STORAGE_APP}/products/${code.toLowerCase().replace(/\s/g, '-')}.jpg`;

// URL-friendly product slug used in /products/:slug routing.
export const codeToSlug = (code) =>
  code.toLowerCase().replace(/\s/g, '-');

export const slugToCode = (slug) => {
  // Try exact reverse ('gv-4439' -> 'GV 4439')
  const pretty = slug.toUpperCase().replace(/-/g, ' ');
  return PRODUCTS[pretty] ? pretty : null;
};

export const getProductBySlug = (slug) => {
  const code = slugToCode(slug);
  return code ? PRODUCTS[code] : null;
};

export const getSetsForProduct = (code) =>
  SETS.filter((s) => s.items.includes(code));

export const getSetHero = (slug) =>
  `${API_BASE}/api/files/${STORAGE_APP}/products/set-${slug}.jpg`;

// A named, purpose-generated variant of a product photo (e.g. 'hero').
export const getProductImageVariant = (code, variant) =>
  `${API_BASE}/api/files/${STORAGE_APP}/products/${code.toLowerCase().replace(/\s/g, '-')}-${variant}.jpg`;
